export default "__VITE_ASSET__by$fxI4V__"